import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    DataSelect,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffShopsNew(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formManagerName, setFormManagerName] = useState(null);
    const [formCityId, setFormCityId] = useState(null);
    const [formCityIdOptions, setFormCityIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-shops-new/select-data/city-id').then((response) => {
            setFormCityIdOptions(response.data);
        });
    }, []);
    const [formAddress, setFormAddress] = useState(null);
    const [formPostCode, setFormPostCode] = useState(null);
    const [formPhone, setFormPhone] = useState(null);
    const [formGatewayKeyNew, setFormGatewayKeyNew] = useState(null);
    const [formWebsite, setFormWebsite] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-shops-new/save-data', {
            title: formTitle,
            manager_name: formManagerName,
            city_id: formCityId,
            address: formAddress,
            post_code: formPostCode,
            phone: formPhone,
            gateway_key_new: formGatewayKeyNew,
            website: formWebsite,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
        console.log('page-dialog');
    };
    return (
        <PanelBox>
            <DataForm>
                <Title>ایجاد رکورد جدید</Title>
                <Grid>
                    <GridColumn width={12}>
                        <Grid>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'عنوان'}
                                    value={formTitle}
                                    onChange={setFormTitle}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'نام مدیر'}
                                    value={formManagerName}
                                    onChange={setFormManagerName}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <DataSelect
                                    label={'شهر'}
                                    options={formCityIdOptions}
                                    value={formCityId}
                                    onChange={setFormCityId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'آدرس'}
                                    value={formAddress}
                                    onChange={setFormAddress}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'کد پستی'}
                                    value={formPostCode}
                                    onChange={setFormPostCode}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <TextBox label={'تلفن'} value={formPhone} onChange={setFormPhone} />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'کلید گیت وی جدید'}
                                    value={formGatewayKeyNew}
                                    onChange={setFormGatewayKeyNew}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'وبسایت'}
                                    value={formWebsite}
                                    onChange={setFormWebsite}
                                />
                            </GridColumn>
                            <GridColumn width={4}></GridColumn>
                        </Grid>
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
